<script setup>
import { ref } from "vue"
const name = ref('Product Analytics')
</script>

<template>
  <c-header
    class="fixed-header"
    :site-name="name"
    site-url="/"
  />
</template>

<style scoped>
.fixed-header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: white;
  z-index: 1000;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}
</style>
